import  { useState } from "react";
import { useNavigate } from "react-router";
import TermsAndCondition from "./TermsAndCondition";
import Indemity from "./Indemity";

const KYCLevelFourDetails = ({ onBack, data, reload, setReload }) => {
  const [step, setStep] = useState("requirements");
  const navigate = useNavigate();
  const { onboardingProgress = {}, onboardingStatus } = data;

  // Safely destructure pendingItems
  const { pendingItems } = onboardingProgress || {};

  const proceedToNextStep = (requirement) => {
    if (requirement && requirement.item) {
      setStep(requirement.item); // Set the step dynamically based on the requirement
    }
  };

  const transformLabel = (item) => {
    const formattedItem = item.replace("_", " ");

    console.log("formattedItem", formattedItem);

    switch (formattedItem) {
      case "upload tac":
        return "Terms and condition";
      case "upload indemnity":
        return "indemnity term";
      default:
        return formattedItem;
    }
  };

  if (step === "upload_tac") {
    return (
      <TermsAndCondition
        onBack={() => setStep("requirements")}
        refresh={reload}
        setRefresh={setReload}
        data={data}
      />
    );
  }

  if (step === "upload_indemnity") {
    return (
      <Indemity
        onBack={() => setStep("requirements")}
        refresh={reload}
        setRefresh={setReload}
        data={data}
      />
    );
  }

  return (
    <div className="w-full md:w-[550px] mx-auto p-4">
      <button onClick={onBack} className="text-blue-600 text-sm mb-4">
        Back
      </button>
      <h3 className="text-xl font-semibold text-gray-800 mb-4">
        Level Two KYC Details
      </h3>
      <div className="bg-primary-color text-white text-lg rounded-lg px-6 py-4 flex justify-between items-center my-[50px]">
        <span>Verification Requirements</span>
        <button
          onClick={() => proceedToNextStep(pendingItems[0])}
          className="bg-white text-primary-color font-semibold px-8 py-4 rounded-md"
        >
          Proceed
        </button>
      </div>
      <div className="border border-gray-300 rounded-b-lg">
        {/* <div className="flex items-center px-4 py-8 border-b border-gray-200">
          <div className="w-6 h-6 flex items-center justify-center rounded-full border-2 border-deeper-blue mr-4">
            <div className="w-3 h-3 rounded-full bg-deeper-blue"></div>
          </div>
          <span className="text-gray-700">Terms & Condition</span>
        </div>
        <div className="flex items-center px-4 py-8 border-b border-gray-200">
          <div className="w-6 h-6 flex items-center justify-center rounded-full border-2 border-deeper-blue mr-4">
            <div className="w-3 h-3 rounded-full bg-deeper-blue"></div>
          </div>
          <span className="text-gray-700">Indemnity Agreement</span>
        </div> */}

        {pendingItems?.map((requirement, index) => (
          <div
            key={index}
            className={`flex items-center px-4 py-8 border-b border-gray-200 ${
              step === requirement.item ? "bg-gray-50" : ""
            }`}
          >
            <div className="w-6 h-6 flex items-center justify-center rounded-full border-2 border-deeper-blue mr-4">
              <div className="w-3 h-3 rounded-full bg-deeper-blue"></div>
            </div>
            <span className="text-gray-700 capitalize">
              {transformLabel(requirement?.item)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KYCLevelFourDetails;
